export default __webpack_public_path__ + "media/lib.1011905a.jpg";